import { RANK_LABELS, RANK_COLORS } from "../lib/format";

export const RankBadge = ({ rank, size = "sm" }) => {
  const colors = RANK_COLORS[rank] || RANK_COLORS.Consultor;
  const label = RANK_LABELS[rank] || rank;
  const sizeCls = size === "sm" ? "text-[11px] px-2 py-0.5" : "text-xs px-2.5 py-1";
  return (
    <span
      className={`inline-flex items-center font-medium rounded-full ring-1 ${colors.bg} ${colors.text} ${colors.ring} ${sizeCls}`}
      data-testid={`rank-badge-${rank.replace(/\s+/g, "-").toLowerCase()}`}
    >
      {label}
    </span>
  );
};